export const MELEE_RULES = {
  killsForFury: 10,
  furySeconds: 5,
  furyDamageMultiplier: 2,
  furyReachMultiplier: 1.25,
  furyArcMultiplier: 1.25,
  critChancePerUpgradeLevel: 0.1,
  critDamageMultiplier: 2,
} as const;
